import { Input, Button } from 'semantic-ui-react';
import CrecerSurveyAnswers from './crecerUserAnswers';
import AGTable from '../../../components/table/aggrid';
import { useRef } from 'react';
import { SurveysColumnDefs } from 'src/components/common/rows/Surveys';
import { CrecerAdminTableContent } from 'src/assets/styles/components/clase3Answers';

const AllSurveyAnswers = (props) => {
  const {
    showAnswers,
    getInfo,
    loading,
    allAnswers,
    handleInputs,
    set_showAnswers,
    getAttendantInfo,
    inputs,
  } = props;

  const gridRef = useRef(null);

  const onEnter = (e) => {
    if (e.key === 'Enter') {
      getInfo();
    }
  };

  const onGridReady = (params) => {
    if (gridRef.current) {
      gridRef.current = params.api;
    }
  };

  const AnswerSelected = allAnswers.find((Answer, i) => showAnswers === Answer.id);

  return (
    <>
      {!showAnswers && (
        <CrecerAdminTableContent>
          <Button onClick={() => getAttendantInfo()}>Descargar con filtro</Button>
          <div>
            <Input
              loading={loading}
              name={'keyword'}
              onChange={handleInputs}
              value={inputs.keyword}
              className={'crecerp1c3'}
              style={{
                display: 'inline-block',
                width: '45%',
                margin: ' 7px 0',
              }}
              onKeyPress={onEnter}
              placeholder="Buscar..."
            />
            <Button onClick={() => getInfo()}>Buscar</Button>
          </div>
        </CrecerAdminTableContent>
      )}
      <div>
        {!showAnswers && <p>Total: {allAnswers.length}</p>}

        {!showAnswers && (
          <div style={{ height: '60vh', width: '100%' }}>
            <AGTable
              columnDefs={SurveysColumnDefs(set_showAnswers)}
              rowData={allAnswers}
              tableRef={gridRef}
              onGridReady={onGridReady}
              pagination
              paginationPageSize={50}
              suppressDragLeaveHidesColumns={false}
            />
          </div>
        )}

        {showAnswers && (
          <div key={AnswerSelected.id}>
            <CrecerSurveyAnswers answer={AnswerSelected} set_showAnswers={set_showAnswers} />
          </div>
        )}
      </div>
    </>
  );
};

export default AllSurveyAnswers;
